import AbstractApiService from 'src/services/abstractApiService';
import { api, getAuthorizationToken } from 'pages/APIs';
import axios from 'axios';
import type { dynamicObj } from 'src/pages/assets';

export default class ReportApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  getReport(data: dynamicObj): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }

    return super.post(api.get_document_report, formData);
  }

  async getReportAsXLSX(data: dynamicObj): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }
    formData.append('org_id', this.getOrgId());

    const token = await getAuthorizationToken();
    const response = await axios.post(api.get_report_as_xlsx, formData, {
      responseType: 'blob',
      headers: {
        Authorization: token,
      },
    });
     
    return response;
  }

  async getAIReport(data: dynamicObj): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }

    const token = await getAuthorizationToken();
    const response = await axios.post(api.get_ai_graphical_report, formData, {
      responseType: 'blob',
      headers: {
        Authorization: token,
      },
    });
     
    return response;
  }

  async getReportRequest(data: dynamicObj): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }
    return super.get(api.get_report_request, formData);
  }

  async getPrivateUserRequests(): Promise<any> {
    return super.get(api.get_private_report_requests_by_user);
  }

  async getPublicOrgRequests(): Promise<any> {
    return super.get(api.get_public_report_requests_by_org);
  }

  async getAllOrgRequests(): Promise<any> {
    return super.get(api.get_all_report_requests_by_org);
  }

  async createReportRequest(data: dynamicObj): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }
    return super.post(api.create_report_request, formData);
  }

  async editReportRequest(data: dynamicObj): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }
    return super.post(api.edit_report_request, formData);
  }

  async deleteReportRequest(data: dynamicObj): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }
    return super.delete(api.delete_report_request, formData);
  }
}
